// extracted by mini-css-extract-plugin
export default {"iframe":"root_survey-module__iframe____gia1"};